export * from './core.module';



// WEBPACK FOOTER //
// ./src/core/index.ts